<template>
	<div class="column">
		<Header
			:dataListTwo="dataListTwo"
			:ChnName="dataListDatasMessage.Introduction.ChnName"
		></Header>
		<model1
			:dataListTwo="dataListTwo"
			:dataListDatas="dataListDatas"
			:dataListDatasMessage="dataListDatasMessage"
			:newList="newList"
			v-if="this.msg == '首页'"
		></model1>
		<model2
			:dataListSingle="dataListSingle"
			:msg="msg"
			:totals="totals"
			v-else
		></model2>
		<Footer></Footer>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import magic from '@/../static/common/magic.js';
import $ from 'jquery';

import Header from './hotHeader.vue';
import Footer from '@/components/footer';
import titlebg from '@/assets/main/titlebg.png';
import model1 from './detail1Model.vue';
import model2 from './detail1Model2.vue';
export default {
	props: {},
	components: {
		Header,
		Footer,
		model1,
		model2,
	},
	data() {
		return {
			restaurants: [],
			state: '',
			navData: [], //导航栏数据
			navData2: [], //特殊的6个栏目多请求一个导航栏数据
			topTitle: '二级栏目', //左侧导航头部标题
			currentChoose: '', //当前选中的栏目uid
			currentModel: '', //当前调用的模板1-0/1-1/1-2:国际概览,2:默认,3:碳排放
			location: [], //获取位置数据
			urlName: magic.getUrlKey('name'), //获取url的参数name
			times: ['2023', '2022', '2021', '2024'],
			year: '2023',
			inputContent: '',
			msg: '首页',
			msgItem: {},
			dataListTwo: [], //导航内容
			dataListDatas: [], //首页的文章列表
			dataListDatasMessage: {
				Introduction: '',
				article: '',
			}, //首页背景文章，标题，图片等
			dataListSingle: [], //除首页的列表
			newList: [], //热点专题
			itemId: '',
			totals: 200,
		};
	},
	computed: {},
	created() {
		this.apiIt();
	},
	mounted() {
		this.$bus.$on('aMsg', (all) => {
			//根据amsg的值
			this.msg = all.msg;
			//如果不是首页
			if (all.msg == '首页') {
				this.$router.push({
					path: '/index',
				});
			} else {
				//存一下id
				this.itemId = all.item.id;
				//获取当页的列表
				this.getLeafIdData(all.item.id)
					.then((value) => {
						this.dataListSingle = value;
					})
					.catch((error) => {
						// 捕获Promise对象变为rejected状态后的错误
						console.error(error);
					});
			}
			// 埋点
			try {
				//LogCollection.contents["key"]="value";
				//0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
				//2：收藏
				//3：下载
				//4：分享
				//5：购买
				//6：登录
				//7：注册
				//9：搜索
				//10：复制
				//11：点赞
				//12：评论
				LogCollection.send(0);
			} catch (e) {}
		});
		this.$bus.$on('current', (number) => {
			this.getLeafIdData(this.itemId, 20, number)
				.then((value) => {
					this.totals = 200;
					this.dataListSingle = value;
				})
				.catch((error) => {
					// 捕获Promise对象变为rejected状态后的错误
					console.error(error);
				});
		});
		this.$bus.$on('goReload', (flag) => {
			if (flag) {
				this.apiIt();
				window.scrollTo(0, 0);
			}
		});
	},
	methods: {
		apiIt() {
			let that = this;
			//获取文章列表
			api.getLeafByChnId(this.$route.query.chnId).then((res) => {
				this.dataListTwo = res.data;
				this.dataListDatas = [];
				let promises = [];

				for (let index = 0; index < res.data.length; index++) {
					let promise = this.getLeafIdData(res.data[index].id)
						.then((value) => {
							return {
								name: res.data[index].name,
								items: res.data[index],
								value: value,
							};
						})
						.catch((error) => {
							// 捕获Promise对象变为rejected状态后的错误
							console.error(error);
						});

					promises.push(promise);
				}

				Promise.all(promises)
					.then((results) => {
						//console.log(results);
						this.dataListDatas = results;
					})
					.catch((error) => {
						console.error(error);
					});
			});
			//根据获取标题，图片
			api.getSpecialTopicFine(this.$route.query.chnId).then((res) => {
				this.dataListDatasMessage.article = res.data;
			});
			//根据背景文章
			api.getSpecialTopicDetail(this.$route.query.chnId).then((res) => {
				this.dataListDatasMessage.Introduction = res.data;
			});
			let params = {
				chnid: '7392',
				pagesize: 6,
				curpage: 1,
				topNumber: 100,
			};
			//热点专题
			api.getTopListByChnIdAndYear(params).then((res) => {
				this.newList = res.data.dataList;
			});
		},
		async getLeafIdData(params, pagesize, curpage) {
			//根据获取文章列表
			let param = {
				leafId: params,
				pagesize: pagesize || 30,
				curpage: curpage || 1,
			};
			let { data } = await api.getDocListByLeafId(param);
			return data;
			// api.getDocListByLeafId(param).then((res) => {
			// 	return res.data;
			// });
		},
		getLeafIdDatatest(params, pagesize, curpage) {
			//根据获取文章列表
			let param = {
				leafId: params,
				pagesize: pagesize || 30,
				curpage: curpage || 1,
			};
			let { data } = api.getDocListByLeafId(param);
			return data;
			// api.getDocListByLeafId(param).then((res) => {
			// 	return res.data;
			// });
		},
	},
};
</script>
<style scoped lang="less">
.column {
	width: 100%;
	// height: 100%;
	background: #f2f2f2;
}
.colunm_main_box {
	width: 1300px;
	margin: 0 auto;
	min-height: 600px;
}
.column_top_nav {
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #1a1a1a;
	line-height: 26px;
	height: 54px;
	line-height: 54px;
}
.column_top_nav .active {
	color: #4eac41;
}
.column_center_box {
	width: 100%;
	overflow: hidden;
	margin-bottom: 50px;
}
// 左侧导航部分
.column_l_nav_box {
	float: left;
	width: 260px;
	// min-height: 460px;
	padding: 20px;
	background: #fff;
	border: 1px solid #e9e9e9;
	box-shadow: 0px 0px 6px 0px #eeeeee;
	position: relative;
	padding-bottom: 232px;
}
.column_l_nav_title {
	width: 260px;
	height: 50px;
	text-align: center;
	line-height: 50px;
	font-size: 18px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #f7f7f7;
	background: url('../../../assets/main/titlebg.png') no-repeat center;
	background-size: cover;
	margin-bottom: 20px;
}
.column_l_nav_title2 {
	width: 260px;
	height: 50px;
	line-height: 50px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #439238;
	margin-bottom: 10px;
	margin-top: 10px;
	border-bottom: 1px solid #439238;
	font-size: 16px;
	text-align: center;
}
.column_l_nav_item {
	background: #f2f2f2;
	margin-bottom: 8px;
	font-size: 15px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	color: #3f433f;
}
.column_l_nav_img {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
}
.column_l_nav_style1 {
	font-size: 15px;
	font-family: Source Han Sans CN;
	font-weight: bold;
	// color: #3F433F;
}
.column_l_nav_style2 {
	border-bottom: 1px solid #f3f3f3;
	font-size: 18px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #8c8c8c;
}
.column_l_nav_style3 {
	font-size: 13px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #808080;
}
.column_l_nav_style3:hover {
	color: #4eac41;
}

// 右侧显示部分
.column_r_box {
	float: right;
	width: 950px;
	// padding:14px 30px;
	min-height: 578px;
	// background: #FFFFFF;
	border: 1px solid #e9e9e9;
	box-shadow: 0px 0px 6px 0px #eeeeee;
}
/deep/ .inline-input {
	.el-input {
		margin-bottom: 17px;
	}
	.el-input__inner {
		width: 258px;
		background: #ececec;
		border: 1px solid #c5c5c5;
		// margin-bottom: 17px;
		// border: none !important;
		border-radius: 0px !important;
		height: 35px !important;
		line-height: 35px !important;
		color: #999999 !important;

		font-size: 14px;
	}
	::placeholder {
		font-size: 14px;
		color: #999999; /* 将颜色更改为您想要的颜色值 */
	}
	.el-input__suffix {
		// height: 0;
	}
	.el-input__icon {
		line-height: 35px;
		cursor: pointer;
	}
}
.my-autocomplete {
	li {
		line-height: normal;
		padding: 7px;

		.name {
			text-overflow: ellipsis;
			overflow: hidden;
		}
		.addr {
			font-size: 12px;
			color: #b4b4b4;
		}

		.highlighted .addr {
			color: #ddd;
		}
	}
}
.timelist {
	margin-top: 25px;
	padding-left: 30%;
	p {
		border-left: 1px solid #cfd3da;
		height: 72px;
		position: absolute;
		top: 20px;
		left: 14px;
	}
	li + li {
		margin-top: 60px;
	}
	li {
		position: relative;
		cursor: pointer;
		padding-left: 42px;
	}
	li:last-child p {
		border-left: 0;
	}
	li:hover {
		.classA {
			font-weight: bold;
			font-size: 18px;
			color: #238c3e;
			line-height: 24px;
		}
		background: url(../../../assets/hot/point_hover1.png) no-repeat 5px 3px;
	}
}
.redbg {
	.classA {
		font-weight: bold;
		font-size: 18px;
		color: #238c3e;
		line-height: 24px;
	}
	background: url(../../../assets/hot/point_hover1.png) no-repeat 5px 3px;
}
.blackbg {
	.classA {
		font-size: 18px;
		color: #333333;
		line-height: 24px;
	}
	background: url(../../../assets/hot/point1.png) no-repeat 5px 3px;
}
</style>



// WEBPACK FOOTER //
// src/view/hotcolumn/hotdetail/index.vue